export default __webpack_public_path__ + "static/media/IMG_0424 copie.a990ef97.jpg";